import React, { useState, useEffect, useMemo } from "react";
import _ from "lodash";
import {
  Typography,
  Grid,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Radio,
  Box,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Switch,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useQuery } from "@apollo/react-hooks";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import { SURVEYS, SURVEY_FORM } from "./queries";
import QuestionsScreen from "./QuestionsScreen";
import CustomTooltip from "../../../../components/CustomTooltip";

const useStyles = makeStyles((theme) => ({
  questionFormWrapper: {
    marginTop: "3rem",
  },
  visualizationType: {
    display: "flex",
    flexDirection: "column",
    marginRight: "1rem",
  },
  visualizationLegend: {
    color: theme.palette.text.secondary,
    fontWeight: 600,
    margin: "10px 0",
  },
  highlightText: {
    fontWeight: "bold",
    color: "#003475",
  },
  iconBlack: {
    color: "black",
  },
}));

function SurveyForm(props) {
  if (!props.surveyId) return null;

  const classes = useStyles();

  const [sector, setSector] = useState(null);
  const [dimension, setDimension] = useState(null);
  const [topic, setTopic] = useState(null);
  const [theme, setTheme] = useState(null);
  const [group, setGroup] = useState(null);

  const [subtopic, setSubtopic] = useState(null);

  // const [subtopics, setSubtopics] = useState([]);
  // const [groups, setGroups] = useState([]);

  const [visualizationType, setVisualizationType] = useState("newModel");
  const [hasReference, setHasReference] = useState(false);

  const {
    loading,
    error,
    data = {},
  } = useQuery(SURVEY_FORM, {
    variables: { surveyId: props.surveyId },
  });
  const surveyFormData = data.surveyForm || {};
  const sectors = surveyFormData.allSectors;
  // links
  const sectorTopicIds = useMemo(() => {
    return new Set(
      (data.topicsPerSectors || [])
        .filter(({ sectorId }) => !sector || sector.id === sectorId)
        .map(({ tagId }) => tagId),
    );
  }, [data, sector]);

  const sectorThemeIds = useMemo(() => {
    return new Set(
      (data.subtopicsPerSectors || [])
        .filter(({ sectorId }) => !sector || sector.id === sectorId)
        .map(({ tagId }) => tagId),
    );
  }, [data, sector]);

  const sectorGroupIds = useMemo(() => {
    return new Set(
      (data.groupingsPerSectors || [])
        .filter(({ sectorId }) => !sector || sector.id === sectorId)
        .map(({ tagId }) => tagId),
    );
  }, [data, sector]);

  const topics = useMemo(() => {
    if (sector) {
      return (surveyFormData.topics || []).filter(({ id }) =>
        sectorTopicIds.has(id),
      );
    }

    return surveyFormData.topics;
  }, [data, dimension, topic, sector]);

  // collections
  const themes = useMemo(() => {
    if (topic) {
      return (topic.themes || []).filter(({ id }) => sectorThemeIds.has(id));
    }

    return [];
  }, [data, dimension, topic, sector]);

  const groups = useMemo(() => {
    if (theme) {
      return (theme.groups || []).filter(({ id }) => sectorGroupIds.has(id));
    }

    return [];
  }, [data, dimension, topic, sector, theme]);

  console.log({
    sector,
    dimension,
    topic,
    theme,
    group,
    surveyFormData,
    sectors,
    topics,
    sectorThemeIds,
    sectorGroupIds,
    themes,
    groups,
  });

  const handleChangeSector = (event) => {
    const sectorId = Number(event.target.value);
    if (sectorId) {
      setSector(sectors.find(({ id }) => id === sectorId));
    } else {
      setSector(null);
    }
  };

  const handleChangeTopic = (event) => {
    const topicId = Number(event.target.value);
    if (topicId) {
      setTopic(topics.find(({ id }) => id === topicId));
    } else {
      setTopic(null);
    }
  };

  const handleChangeTheme = (event) => {
    const themeId = Number(event.target.value);
    if (themeId) {
      setTheme(themes.find(({ id }) => id === themeId));
    } else {
      setTheme(null);
    }
  };

  const handleChangeGroup = (event) => {
    const groupId = Number(event.target.value);
    if (groupId) {
      setGroup(groups.find(({ id }) => id === groupId));
    } else {
      setGroup(null);
    }
  };

  useEffect(() => {
    setTopic(topics && topics.length > 0 ? topics[0] : null);
    setTheme(null);
    setGroup(null);
  }, [data, sector]);

  useEffect(() => {
    setTheme(null);
    setGroup(null);
  }, [data, topic]);

  useEffect(() => {
    setGroup(null);
  }, [data, theme]);

  // const subtopicsForCurrentTopicAndSector = (topic, sector) => {
  //   const subtopicsForCurrentSector = [
  //     ...new Set(
  //       data.subtopicsPerSectors
  //         .filter((subtopic) => subtopic.sectorId === sector)
  //         .map((e) => e.tagId),
  //     ),
  //   ];

  //   return surveyFormData.allTopics
  //     .find((_topic) => _topic.id === topic)
  //     .subtopics.filter((subtopic) => {
  //       if (!sector) return true;
  //       return subtopicsForCurrentSector.find(
  //         (subtopicId) => subtopicId === subtopic.id,
  //       );
  //     })
  //     .sort((a, b) => a.name.localeCompare(b.name));
  // };

  // const handleTopicChange = (event) => {
  //   const selectedTopic =
  //     typeof event === "number" ? event : event.target.value;

  //   setTopic(selectedTopic);
  //   setSubtopic(0);
  //   setSubtopics(subtopicsForCurrentTopicAndSector(selectedTopic, sector));
  //   setGroup(0);
  //   setGroups([]);
  // };

  // const handleSectorChange = (event) => {
  //   setSector(event.target.value);
  //   setSubtopics(subtopicsForCurrentTopicAndSector(topic, event.target.value));
  //   setGroup(0);
  //   setGroups([]);
  // };

  // const handleSubtopicChange = (subtopicId) => {
  //   setSubtopic(subtopicId);
  //   if (subtopicId !== 0) {
  //     const subtopicData = subtopics.find(
  //       (_subtopic) => _subtopic.id === subtopicId,
  //     );
  //     if (subtopicData) {
  //       console.log(data.groupingsPerSectors);
  //       console.log(subtopicData.groups);
  //       setGroups(
  //         (subtopicData.groups || [])
  //           .filter(({ id }) => {
  //             return data.groupingsPerSectors.find(({ tagId }) => tagId === id);
  //           })
  //           .sort((a, b) => a.name.localeCompare(b.name)),
  //       );
  //     }
  //   } else {
  //     setGroups([]);
  //   }
  // };

  if (error) {
    return <Typography>Erro ao carregar - {error.message}</Typography>;
  }

  if (loading) {
    return null;
  }

  if (!dimension && !_.isEmpty(surveyFormData.allDimensions)) {
    setDimension(surveyFormData.allDimensions[0].id);
  }
  if (!topic && !_.isEmpty(surveyFormData.allTopics)) {
    const defaultTopic = surveyFormData.allTopics[0];
    handleTopicChange(defaultTopic.id);
    // setSubtopic(defaultTopic.subtopics[0].id)
  }

  return (
    <>
      <Grid item xs={12}>
        <Grid item xs={12} md={3}>
          <CustomTooltip title="Escolha o setor de seu interesse, ou “todos os setores” para uma visão geral">
            <FormControl variant="outlined" fullWidth>
              <InputLabel>Setor</InputLabel>
              <Select
                value={sector ? sector.id : 0}
                onChange={handleChangeSector}
                label="Escolha um setor"
              >
                <MenuItem key={0} value={0}>
                  Todos os Setores
                </MenuItem>

                {sectors.map((sector, key) => (
                  <MenuItem key={key} value={sector.id}>
                    {sector.b3Name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </CustomTooltip>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={12}>
            <FormLabel
              className={classes.visualizationLegend}
              component="legend"
            >
              Visualização
            </FormLabel>
          </Grid>
          <Grid item xs={12}>
            <FormControl variant="outlined" fullWidth>
              <FormControl component="fieldset">
                <RadioGroup
                  aria-label="visualization"
                  value={visualizationType}
                  onChange={(event) => setVisualizationType(event.target.value)}
                  row
                >
                  <Grid container item xs={12} justify="flex-start">
                    <Grid item xs={12} md={9}>
                      <FormControl
                        className={classes.visualizationType}
                        variant="outlined"
                      >
                        <Grid container item direction="column">
                          <CustomTooltip title="Mostra as perguntas do questionário atual, mas FILTRADAS E AGRUPADAS pelos temas">
                            <FormControlLabel
                              value="newModel"
                              control={<Radio />}
                              label="Selecione a dimensão e o tema/tópico que deseja consultar"
                            />
                          </CustomTooltip>

                          <Grid container item direction="row" spacing={2}>
                            <Grid item xs={12} md={4}>
                              <CustomTooltip title="Escolha a DIMENSÃO que quer visualizar">
                                <Select
                                  fullWidth
                                  value={topic ? topic.id : 0}
                                  onChange={handleChangeTopic}
                                  label="Todas as dimensões"
                                  disabled={visualizationType === "standard"}
                                >
                                  {topics.length === 0 ? (
                                    <MenuItem key={"t"} disabled={true}>
                                      -
                                    </MenuItem>
                                  ) : null}

                                  {topics.map((topic, key) => (
                                    <MenuItem key={key} value={topic.id}>
                                      {topic.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </CustomTooltip>
                            </Grid>

                            <Grid item xs={12} md={4}>
                              <CustomTooltip title="Escolha o TEMA que quer visualizar">
                                <Select
                                  fullWidth
                                  value={theme ? theme.id : 0}
                                  onChange={handleChangeTheme}
                                  label="Todos os temas"
                                  disabled={visualizationType === "standard"}
                                >
                                  {themes.length > 0 ? (
                                    <MenuItem key={-1} value={0}>
                                      Todos os temas
                                    </MenuItem>
                                  ) : (
                                    <MenuItem key={"t"} disabled={true} value={0}>
                                      -
                                    </MenuItem>
                                  )}

                                  {themes.map((theme, key) => (
                                    <MenuItem key={key} value={theme.id}>
                                      {theme.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </CustomTooltip>
                            </Grid>

                            <Grid item xs={12} md={4}>
                              <CustomTooltip title="Escolha o TÓPICO que quer visualizar">
                                <Select
                                  fullWidth
                                  value={group ? group.id : 0}
                                  onChange={handleChangeGroup}
                                  label="Todos os tópicos"
                                  disabled={visualizationType === "standard"}
                                >
                                  {(groups.length > 0 || themes.length > 0) ? (
                                    <MenuItem key={-1} value={0}>
                                      Todos os Tópicos
                                    </MenuItem>
                                  ) : (
                                    <MenuItem key={"t"} disabled={true} value={0}>
                                      -
                                    </MenuItem>
                                  )}

                                  {groups.map((group, key) => (
                                    <MenuItem key={key} value={group.id}>
                                      {group.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </CustomTooltip>
                            </Grid>
                          </Grid>
                        </Grid>
                      </FormControl>
                    </Grid>
                  </Grid>
                </RadioGroup>
              </FormControl>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container>
          <CustomTooltip title="Quando ativo, exibe a referência, protocolo e documento para cada questão.">
            <FormControlLabel
              control={
                <Switch
                  checked={hasReference}
                  onChange={() => setHasReference(!hasReference)}
                  name="References"
                  color="secondary"
                />
              }
              label="Mostrar detalhes"
            />
          </CustomTooltip>
        </Grid>
      </Grid>

      <Grid item xs={12} className={classes.explanatoryText}>
        <Box mx={5} mt={2} p={1} style={{ background: "#faa74a" }}>
          <Typography align="center" color="secondaryColorLight">
            Clique nas alternativas para ver os temas/tópicos e setores
            associados a elas.
          </Typography>
        </Box>
      </Grid>

      {/* {
        <Grid item xs={ 12 }>
          {
            subtopics.map((s, i) => <><p>{ i } - { s.name }</p><br /></>)
          }
        </Grid>
      } */}

      <Grid item xs={12} className={classes.questionFormWrapper}>
        <QuestionsScreen
          surveyId={props.surveyId}
          visualizationType={visualizationType}
          dimensionId={dimension}
          topicId={topic ? topic.id : null}
          subtopicId={theme ? theme.id : null}
          groupId={group ? group.id : null}
          sectorId={sector ? sector.id : null}
          subtopicsPerSectors={data.subtopicsPerSectors}
          userProfile={props.userProfile}
          hasReference={hasReference}
        />
      </Grid>
    </>
  );
}

function SurveyPreview(props) {
  const classes = useStyles();

  const [survey, setSurvey] = React.useState(null);
  const {
    loading: loadingSurveys,
    error: errorSurveys,
    data: dataSurveys,
  } = useQuery(SURVEYS, {
    // pollInterval: 1500
  });

  if (errorSurveys) {
    return <p> {errorSurveys.message}</p>;
  }

  if (loadingSurveys) {
    return (
      <Grid container item justify="center">
        <CircularProgress />
      </Grid>
    );
  }

  if (!survey && !_.isEmpty(dataSurveys.allSurveys)) {
    setSurvey(+dataSurveys.allSurveys[0].id);
  }

  return (
    <Grid container spacing={2} justify="flex-start">
      <Grid item xs={12}>
        <Box mb={3}>
          <Typography align="justify">
            Nesta consulta você pode conhecer e comentar as versões preliminares
            de: Questionários do ISE B3, evidências esperadas em cada questão e
            seus respectivos protocolos.
            <br />
            <br />
            Ressaltamos que o questionário está organizado em dimensões, temas e
            tópicos adaptados conforme o setor.
            <br />
            Por isso, use os filtros para acessar o conteúdo de seu interesse.
          </Typography>

          <Typography
            align="justify"
            className={classes.highlightText}
            style={{
              backgroundColor: "#cce5ff",
              border: "1px solid #b8daff",
              padding: "8px 16px",
              borderRadius: "4px",
              marginTop: "8px",
              marginBottom: "16px",
            }}
          >
            <ul
              style={{
                paddingLeft: "22px",
                marginTop: "0",
                marginBottom: "0",
              }}
            >
              <li
                style={{
                  listStyle: "disc",
                }}
              >
                Para uma visão geral do questionário e de sua estrutura,{" "}
                <a href="https://bit.ly/Vs_Geral_CP_NOVO_ISEB3 ">
                  {" "}
                  acesse este link.{" "}
                </a>
                .
              </li>
              <li
                style={{
                  listStyle: "disc",
                }}
              >
                Para baixar a versão integral,{" "}
                <a href="https://bit.ly/V_Integral_CP_NovoISEB3">
                  {" "}
                  acesse este link.{" "}
                </a>
              </li>
              <li
                style={{
                  listStyle: "disc",
                }}
              >
                Para baixar a comparação entre a versão original e a nova,
                <a href="https://bit.ly/Comparativo-CP-NovoISEB3">
                  {" "}
                  acesse este link.{" "}
                </a>
              </li>
            </ul>
          </Typography>
          <Typography align="justify" className={classes.highlightText}>
            Para comentar, clique no ícone{" "}
            <QuestionAnswerIcon
              fontSize="small"
              className={classes.iconBlack}
            />{" "}
            ao lado de cada pergunta.
            <br />
            Além dos comentários em cada pergunta, é possível relatar um
            comentário ou dúvidas na pesquisa geral sobre os novos
            questionários,
            <a href="https://forms.office.com/r/eGrwzAWdcF">
              {" "}
              disponível aqui.{" "}
            </a>
            <br />
            <br />
            <u>Prazo limite: 24/04/2026</u>
          </Typography>
          <Typography
            align="justify"
            className={classes.highlightText}
            style={{
              backgroundColor: "#cce5ff",
              border: "1px solid #b8daff",
              padding: "8px 16px",
              borderRadius: "4px",
              marginTop: "16px",
              marginBottom: "16px",
            }}
          >
            Questões orientadoras para seus comentários e sugestões:
            <ul
              style={{
                paddingLeft: "22px",
                marginBottom: "0",
              }}
            >
              <li
                style={{
                  listStyle: "disc",
                }}
              >
                <u>Conteúdo e cobertura de cada tema/tópico</u>: Falta algo?
                Sobra algo? Há algo fora do lugar?
              </li>
              <li
                style={{
                  listStyle: "disc",
                }}
              >
                <u>Correção e clareza</u>: As perguntas estão claras? O que
                deveria ser corrigido ou explicado melhor?
              </li>
              <li
                style={{
                  listStyle: "disc",
                }}
              >
                <u>Materialidade e aplicabilidade</u>: Os assuntos das perguntas
                são materiais e aplicáveis aos temas/tópicos e setores
                indicados? As evidências solicitadas são factíveis?
              </li>
              <li
                style={{
                  listStyle: "disc",
                }}
              >
                <u>Experiência de uso</u>: O questionário está longo? Está mais
                fácil de preencher? Há a necessidade de voltar em outras
                perguntas/alternativas para responder?
              </li>
            </ul>
          </Typography>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Grid item xs={12} md={3}>
          {props.userProfile === "administrator" && (
            <CustomTooltip title="Escolha o questionário que deseja visualizar">
              <FormControl variant="outlined" fullWidth>
                <InputLabel>Questionário</InputLabel>
                <Select
                  value={survey}
                  onChange={(event) => setSurvey(event.target.value)}
                  label="Escolha um dos questionários importados"
                  required
                >
                  {dataSurveys.allSurveys.map((survey, key) => (
                    <MenuItem key={key} value={survey.id}>
                      {survey.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </CustomTooltip>
          )}
        </Grid>
      </Grid>

      {survey && (
        <SurveyForm surveyId={survey} userProfile={props.userProfile} />
      )}
    </Grid>
  );
}

export default SurveyPreview;
